import { Component, Inject, Injector } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { VoucherComponent } from '../voucher.component';
import { MatBottomSheetRef, MatBottomSheet, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Subject, takeUntil } from 'rxjs';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.css']
})
export class DetailComponent {
  isDetail: boolean = false;
  isClose: boolean;
  myHtml: String | undefined;
  destroyed = new Subject<void>();
  appServiceScreenDesktop!: boolean;
  appServiceScreenMobile!: boolean;
  appServiceScreenMobileSmall!: boolean;
  data: any = MAT_DIALOG_DATA;
  dataMobile: any = MAT_BOTTOM_SHEET_DATA;

  constructor(
    @Inject(Injector)public injector: Injector,
    private dialogRef: MatDialogRef<DetailComponent>,
    private dialog: MatDialog,
    private bottomSheetRef: MatBottomSheetRef<DetailComponent>,
    private bottomSheet: MatBottomSheet,
    private appService: AppService
  ) {
    appService.breakpointDesktop$.pipe(takeUntil(this.destroyed)).subscribe(result => {
      this.appServiceScreenDesktop = result
    })

    appService.breakpointMobile$.pipe(takeUntil(this.destroyed)).subscribe(result => {
      this.appServiceScreenMobile = result
    })

    appService.breakpointMobileSmall$.pipe(takeUntil(this.destroyed)).subscribe(result => {
      this.appServiceScreenMobileSmall = result
    })

    if(this.appServiceScreenDesktop) {
      this.data = injector.get(MAT_DIALOG_DATA);
    
      this.isClose = this.data == undefined ? this.data['isClose'] : this.data['isClose']
      this.myHtml = this.data == undefined ? '' : this.data['tnc']
    } else {
      this.dataMobile = injector.get(MAT_BOTTOM_SHEET_DATA);

      this.isClose = this.dataMobile == undefined ? this.dataMobile['isClose'] : this.dataMobile['isClose']
      this.myHtml = this.dataMobile == undefined ? '' : this.dataMobile['tnc']
    }
  }

  callDetail() {
    this.isDetail = true
  }

  back_() {
    if(this.appServiceScreenMobile) {
      this.bottomSheetRef.dismiss()
      this.bottomSheet.open(VoucherComponent, { data: {isClose: true} });
    } else {
      this.dialogRef.close()
      this.dialog.open(VoucherComponent, { data: {isClose: true} })
    }
  }

  closeBottomSheet() {
    if(this.appServiceScreenMobile)
      this.bottomSheetRef.dismiss()
  }
}
